import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api.ts";

interface Stats {
  pending_review?: number;
  content_incomplete?: number;
  pending_rewrite?: number;
  rewriting?: number;
  published?: number;
  rejected?: number;
  error?: number;
  browsing?: number;
}

export default function Dashboard() {
  const [stats, setStats] = useState<Stats>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.articles.stats()
      .then(setStats)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  // Refresh stats when window regains focus (e.g. navigating back from Settings)
  useEffect(() => {
    function onFocus() {
      api.articles.stats()
        .then(setStats)
        .catch(console.error);
    }
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, []);

  const cards = [
    { label: "Needs Review",   value: stats.pending_review ?? 0,      color: "text-yellow-600 bg-yellow-50",  to: "/review?status=pending_review" },
    { label: "In Browse View", value: stats.browsing ?? 0,            color: "text-gray-600 bg-gray-50",      to: "/browse" },
    { label: "Content Missing",value: stats.content_incomplete ?? 0,  color: "text-orange-600 bg-orange-50", to: "/review?status=content_incomplete" },
    { label: "Queued / Rewriting", value: (stats.pending_rewrite ?? 0) + (stats.rewriting ?? 0), color: "text-blue-600 bg-blue-50", to: "/review?status=pending_rewrite%2Crewriting" },
    { label: "Published Today",value: stats.published ?? 0,           color: "text-green-600 bg-green-50",    to: "/review?status=published" },
    { label: "Errors",         value: stats.error ?? 0,               color: "text-red-600 bg-red-50",        to: "/review?status=error" },
  ];

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-900">Dashboard</h1>
        <p className="text-gray-500 text-sm mt-1">Pipeline status overview</p>
      </div>

      {loading ? (
        <div className="text-gray-400 text-sm">Loading…</div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
          {cards.map(card => (
            <Link key={card.label} to={card.to}
              className="card p-5 hover:shadow-md transition-shadow">
              <p className="text-sm font-medium text-gray-500">{card.label}</p>
              <p className={`text-3xl font-bold mt-1 ${card.color.split(" ")[0]}`}>
                {card.value}
              </p>
            </Link>
          ))}
        </div>
      )}

      <div className="mt-8 flex gap-3">
        <Link to="/review" className="btn-primary btn">
          Open Review Queue
        </Link>
        <Link to="/browse" className="btn-ghost btn">
          Feed Browse View
        </Link>
      </div>
    </div>
  );
}
